import { Outlet } from 'react-router-dom';
import { AppProviders } from './providers/app.providers';

function App() {
  return (
    <AppProviders>
      <Outlet />
    </AppProviders>
  );
}

export default App;
